<template>
  <div class="close-icon" @click="handleClose">
    <X />
  </div>
</template>

<script lang="ts" setup>
  import { X } from 'lucide-vue-next'
  const emit = defineEmits(['close'])

  function handleClose() {
    emit('close')
  }
</script>

<style lang="scss" scoped>
  .close-icon {
    cursor: pointer;
    transition: all 0.2s ease;
    color: theme('colors.gray[500]');
    &:hover {
      scale: 1.1;
      color: var(--el-color-danger);
    }
  }

  .dark .close-icon {
    color: theme('colors.gray[300]');
  }
</style>
